import React from "react";

import weldLogo from "@/assets/weld.svg";
import classNames from "@/helpers/classNames";

export default function WeldLogo({
  className,
  ...props
}: React.ComponentProps<"img">) {
  return (
    <img
      className={classNames("filter dark:invert", className)}
      src={weldLogo}
      alt="Weld"
      {...props}
    />
  );
}
